import { TextSummaryBase } from "./base"

export class RegionTextSummary extends TextSummaryBase {
  static cssClass = "region-text-summary-block"
  protected readonly urlDatasetKey = "regionTextSummaryUrl"
  protected readonly containerDatasetFlag = "regionTextSummaryContainer"
}

export default RegionTextSummary
